import styled from '@emotion/styled';
import {
  ButtonNormalPrimaryMediumCompact,
  ButtonNormalSecondaryMediumCompact,
  CheckCircleOutlineMediumIcon,
  TextDisplayAlt,
  TextParagraph,
  token,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';
import { useRouter } from 'next/router';

import { CONTRACT, PLAN } from '../../../routes';

const BENEFITS = [
  'Referência em assistência familiar no Sul do Brasil',
  'Benefícios em vida para titular e dependentes',
  'Múltiplos seguros e assistências',
];

export const AssociateSection = () => {
  const router = useRouter();
  const phoneImage = `${router.basePath}/assets/img/hub_phone_mockup.png`;

  return (
    <AssociateSectionContainer>
      <AssociateContent>
        <AssociateLeft>
          <AssociateTitle>Torne-se um associado</AssociateTitle>
          <AssociateDescription>
            Aqui você encontra um plano que é perfeito para você e quem você
            ama.
          </AssociateDescription>
          <BenefitsList>
            {BENEFITS.map((benefit, index) => (
              <BenefitItem key={index}>
                <CheckIconWrapper>
                  <CheckCircleOutlineMediumIcon
                    color={token.colors.feedbackSuccessPrimary}
                  />
                </CheckIconWrapper>
                <BenefitText>{benefit}</BenefitText>
              </BenefitItem>
            ))}
          </BenefitsList>
          <ButtonsContainer>
            <LinkWrapper href={PLAN}>
              <ButtonNormalPrimaryMediumCompact>
                Adquirir Plano
              </ButtonNormalPrimaryMediumCompact>
            </LinkWrapper>
            <LinkWrapper href={CONTRACT}>
              <ButtonNormalSecondaryMediumCompact className="button_secondary_alt">
                Já sou associado
              </ButtonNormalSecondaryMediumCompact>
            </LinkWrapper>
          </ButtonsContainer>
        </AssociateLeft>
        <AssociateRight>
          <PhoneImage src={phoneImage} alt="Angeplus app" />
        </AssociateRight>
      </AssociateContent>
    </AssociateSectionContainer>
  );
};

const AssociateSectionContainer = styled.section`
  background-color: ${token.colors.solidAngeplusForeground};
  padding: 0;
  width: 100%;
`;

const AssociateContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingXLarge};
  justify-content: space-evenly;
  align-items: center;

  @media (min-width: 968px) {
    flex-direction: row;
    gap: ${token.spacing.spacingXxLarge};
  }
`;

const AssociateLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingLarge};
  max-width: 100%;
  padding: ${token.spacing.spacingLarge} ${token.spacing.spacingLarge} 0;

  @media (min-width: 968px) {
    max-width: 600px;
    padding: 0;
  }
`;

const AssociateRight = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0;

  @media (min-width: 968px) {
    padding-top: ${token.spacing.spacingXLarge};
  }
`;

const PhoneImage = styled.img`
  width: 100%;
`;

const AssociateTitle = styled(TextDisplayAlt)`
  color: white !important;
  font-size: 22px;
  line-height: 1.2;

  @media (min-width: 768px) {
    font-size: 40px;
  }
`;

const AssociateDescription = styled(TextParagraph)`
  color: white !important;
  font-size: 14px;
  line-height: 1.5;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const BenefitsList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingMedium};
  list-style: none;
  padding: 0;
  margin: 0;
`;

const BenefitItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${token.spacing.spacingSmall};
`;

const CheckIconWrapper = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
`;

const BenefitText = styled(TextParagraph)`
  color: white !important;
  font-size: 14px;
  line-height: 1.5;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingSmall};
  margin-top: ${token.spacing.spacingSmall};

  @media (min-width: 768px) {
    flex-direction: row;
  }
`;
